
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
  components: { VueSlickCarousel },
  data() {
    return {
      mobileView: true,
      activeItemId: null,

      settings: {
        infinite: true,
        arrows: false,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        speed: 1000,

        responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },

      options: [
        {
          name: "image",
          label: this.$t("label.image"),
          type: "image",
          size: "320x376",
        },
        {
          name: "bgIcon",
          label: this.$t("label.bgIcon"),
          type: "image",
          size: "166x141",
        },
        {
          name: "title",
          label: this.$t("label.title"),
          type: "text",
        },
        {
          name: "description",
          label: this.$t("label.description"),
          type: "tipTap",
        },
        {
          name: "link",
          label: this.$t("label.link"),
          type: "link",
        },
      ],
    };
  },

  mounted() {
    window.addEventListener("resize", this.checkIfMobileView, {
      passive: true,
    });

    this.checkIfMobileView();
  },

  methods: {
    checkIfMobileView() {
      if (window.innerWidth > 767) {
        this.mobileView = false;
      } else this.mobileView = true;
    },

    prevSlide() {
      if (this.$refs.slider) {
        this.$refs.slider.prev();
      }
    },

    nextSlide() {
      if (this.$refs.slider) {
        this.$refs.slider.next();
      }
    },
  },
};
